import { render, staticRenderFns } from "./OriginatorRestrictions.vue?vue&type=template&id=bdf3e51c&"
import script from "./OriginatorRestrictions.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRestrictions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports